// extracted by mini-css-extract-plugin
export default {"CodeSettings":"CodeSettingsXfInlwBh5mXy","CodeSettings-Languages":"CodeSettings-Languages6Hr6WgYUMj19"};